import { isItProductionServer } from '../../constant'

export const loadDesignLabSpotCheck = () => {
    // Create a script element
    const script = document.createElement('script')
    const token = isItProductionServer()
        ? 'tar-hL8BVdKUf6YhF1cvfri3yR'
        : 'tar-pwqnvdYdXcqdtzqndyzte1'

    // Create a blob from the script content
    const scriptContent = `
        (function () {
            var e = 'ss-widget',
                t = 'script',
                a = document,
                r = window
            var s, n, c
            r.SP_TARGET_TOKEN = '${token}'
            r.SS_SP_ACCOUNT = 'nitex.surveysparrow.com'
            if (!a.getElementById(e)) {
                var S = function () {
                    S.update(arguments)
                }
                S.args = []
                S.update = function (e) {
                    S.args.push(e)
                }
                r.SpotCheckLauncher = S
                s = a.getElementsByTagName(t)
                c = s[s.length - 1]
                n = a.createElement(t)
                n.type = 'text/javascript'
                n.async = !0
                n.id = e
                n.src = [
                    'https://',
                    'nitex.surveysparrow.com/spotcheck/widget/',
                    r.SP_TARGET_TOKEN
                ].join('')
                n.onload = function () {
                    const userInfo = JSON.parse(
                        localStorage.getItem('userInfo') || '{}'
                    )
                    if (window.SpotCheckLauncher) {
                        window.SpotCheckLauncher('popup', {
                            userDetails: {
                                email: userInfo?.email,
                                firstName: userInfo?.name
                            },
                            variables: {
                                user_name: userInfo?.name,
                                user_email: userInfo?.email,
                                user_id: userInfo?.id?.toString(),
                                user_type: userInfo?.primaryUserType
                            },
                            properties: {}
                        })
                    }
                }
                c.parentNode.insertBefore(n, c)
            }
        })()
    `

    // Create a blob URL from the script content
    const blob = new Blob([scriptContent], { type: 'text/javascript' })
    const blobUrl = URL.createObjectURL(blob)

    // Set the script source to the blob URL
    script.src = blobUrl
    script.id = 'ss-spot-script'
    script.async = true

    // Clean up the blob URL after the script loads
    script.onload = () => {
        URL.revokeObjectURL(blobUrl)
    }

    document.body.appendChild(script)
}

export const cleanupDesignLabSpotCheck = () => {
    const script = document.getElementById('ss-spot-script')
    if (script) {
        document.body.removeChild(script)
    }
}
